import { createContext, useContext, useEffect } from 'react'

/** Called with true when a Modal opens and false when it closes. */
export type ModalPresenceReporter = (isOpen: boolean) => void

/**
 * Lets a page react to any Modal under it being open — e.g. an embed asking
 * its host page to promote the iframe to a viewport overlay. Modals report
 * through it; the provider decides what to do.
 */
export const ModalPresenceContext = createContext<ModalPresenceReporter | null>(
  null,
)

/** Reports this Modal's open state to the nearest presence provider. */
export const useReportModalPresence = (isOpen: boolean) => {
  const report = useContext(ModalPresenceContext)
  // tells a provider outside React's tree of data; no derivation
  useEffect(() => {
    if (!isOpen || !report) return
    report(true)
    return () => report(false)
  }, [isOpen, report])
}
